import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import { createClientId as createStoredClientId, safeGetStorageItem, safeSetStorageItem } from './browserStorage';

const MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const CLIENT_ID_KEY = 'yamanoboro_ga_client_id';
const VISIT_DATE_KEY = 'yamanoboro_last_visit_date';
const VISIT_TRACKED_KEY = 'yamanoboro_visit_tracked';

let initialized = false;

function getTodayKey() {
  return new Date().toISOString().slice(0, 10);
}

function getClientId() {
  let clientId = safeGetStorageItem(CLIENT_ID_KEY);
  if (!clientId) {
    clientId = createStoredClientId('ymb');
    safeSetStorageItem(CLIENT_ID_KEY, clientId);
  }
  return clientId;
}

export function initAnalytics() {
  if (initialized || !MEASUREMENT_ID) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', MEASUREMENT_ID, {
    send_page_view: false,
    anonymize_ip: true,
  });

  initialized = true;
}

export function trackPageView(path) {
  if (!MEASUREMENT_ID || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export async function trackVisit(path) {
  const todayKey = getTodayKey();
  const trackedDate = safeGetStorageItem(VISIT_DATE_KEY);
  const tracked = safeGetStorageItem(VISIT_TRACKED_KEY) === '1';

  if (trackedDate === todayKey && tracked) {
    return;
  }

  const callable = httpsCallable(functions, 'trackVisit');
  await callable({
    clientId: getClientId(),
    path,
  });

  safeSetStorageItem(VISIT_DATE_KEY, todayKey);
  safeSetStorageItem(VISIT_TRACKED_KEY, '1');
}

export async function trackRecruitmentView(recruitmentId, path) {
  if (!recruitmentId) return;

  const callable = httpsCallable(functions, 'trackRecruitmentView');
  await callable({
    clientId: getClientId(),
    recruitmentId,
    path,
  });
}
